var exports = {
  "k": "xb99ab02a--8be124--container",
};

module.exports = exports;
